export const MAX_NUMBER_VALUE = 100000000;
export const MIN_NUMBER_VALUE = -MAX_NUMBER_VALUE;
export const MAX_PERCENTAGE_VALUE = 100;
export const MAX_PERCENTAGE_UNLIMITED = 1_000_000_000;
export const MAX_INTEGER_VALUE = 2147483647;

export const DEFAULT_DECIMAL_SCALE = 2;
